// Shared react-select styling for the previous/next target dropdowns: disabled
// targets are greyed out in both the menu and the selected value. Both files
// carried an identical copy of this before they were typed.
const targetOptionStyles = {
  singleValue: (provided: any, { data }: { data: { enabled?: boolean } }) => ({ // selected
    ...provided,
    color: data.enabled === true ? 'defaultColor' : 'grey',
  }),
  option: (provided: any, { data }: { data: { enabled?: boolean } }) => ({ // options
    ...provided,
    color: data.enabled === true ? 'defaultColor' : 'grey',
  }),
};

export default targetOptionStyles;
